import React from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { Pricing } from './pages/Pricing';
import { Contact } from './pages/Contact';
import { Industries } from './pages/Industries';
import { Crm } from './pages/Crm';
import { useHashRoute } from './hooks/useHashRoute';
export function App() {
  const route = useHashRoute();
  return <div className="min-h-screen w-full bg-white font-sans text-gray-900 selection:bg-red-200 selection:text-red-900" data-id="element-0" data-mp="2mluawsf5bxuv">
      <AnnouncementBar data-id="element-1" data-mp="31b8lu4ydencd" />
      <Navbar route={route} data-id="element-2" data-mp="31bibtsjf0ui2" />
      <main data-id="element-3" data-mp="31ctd9lpe1q60">
        {route === 'pricing' && <Pricing data-id="element-4" data-mp="2wjgrdjc3fxgy" />}
        {route === 'contact' && <Contact data-id="element-5" data-mp="2wifhhi6tdh0t" />}
        {route === 'industries' && <Industries data-id="element-6" data-mp="28u5zysgmvffh" />}
        {route === 'crm' && <Crm data-id="element-7" data-mp="28t4jg8gum0qd" />}
        {route === 'home' && <Home data-id="element-8" data-mp="28s2z1ddy01vz" />}
      </main>
      <Footer data-id="element-9" data-mp="23vupcfiil0w7" />
    </div>;
}